var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionTransportTram({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 2h-2l-1 2h3.586A3.414 3.414 0 0 1 20 7.414V18a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V7.414A3.414 3.414 0 0 1 7.414 4H11l1-2H8V0h8v2ZM7 16a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm10 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM6 8v6h12V8H6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.667 22h8.666L15 18h2l2 6H5l2-6h2l-1.333 4Z",
    opacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionTransportTram);
export default __webpack_public_path__ + "static/media/ic_action_transport_tram.b98e34fa2a695712af5ebb8ae5f6310d.svg";
export { ForwardRef as ReactComponent };